import { type ReactNode } from 'react';
export const AiGenerating = ({
  imageSrc,
  prompt,
  description
}: {
  imageSrc: string;
  prompt?: string;
  description: ReactNode;
}) => {
  return <div className="flex size-full flex-col items-center justify-center gap-lg bg-gray-50 p-lg" data-sentry-component="AiGenerating" data-sentry-source-file="AiGenerating.tsx">
      <img className="w-auto" src={imageSrc} alt="ai_generating" />
      {prompt && <div className=" line-clamp-2 w-full text-center text-heading-lg-extrabold text-gray-900">
          {`"${prompt}"`}
        </div>}
      <div>
        <div className="text-center text-heading-sm-bold text-alternative opacity-[0.72] ">
          {description}
        </div>
      </div>
    </div>;
};